import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app/app.config';
import { App } from './app/app';
import { applyRuntimeConfig, environment } from './environments/environment';

function bootstrap(): Promise<unknown> {
  return bootstrapApplication(App, appConfig);
}

function start(): void {
  fetch('assets/config/config.json')
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Config load failed (${response.status})`);
      }
      return response.json();
    })
    .then((config) => applyRuntimeConfig(config))
    .catch((error) => {
      console.error('Failed to load runtime config; falling back to built-in environment', error);
    })
    .then(() => {
      if (environment.production) {
        enableProdMode();
      }
      return bootstrap();
    })
    .catch((error) => console.error(error));
}

start();
